import { useEffect } from "react";

interface ToastProps {
  message: string;
  type?: "success" | "error" | "warning" | "info";
  isVisible: boolean;
  onClose: () => void;
  duration?: number;
}

export function Toast({ message, type = "success", isVisible, onClose, duration }: ToastProps) {
  useEffect(() => {
    if (isVisible && duration !== undefined && duration > 0) {
      const timer = setTimeout(() => {
        onClose();
      }, duration);
      return () => clearTimeout(timer);
    }
  }, [isVisible, duration, onClose]);

  if (!isVisible) return null;

  const bgColors = {
    success: "bg-green-500",
    error: "bg-red-500",
    warning: "bg-amber-500",
    info: "bg-blue-500",
  };

  const icons = {
    success: "✓",
    error: "✕",
    warning: "⚠",
    info: "ℹ",
  };

  return (
    <div className="fixed bottom-4 right-4 z-[9999] animate-slide-in-bottom">
      <div className={`${bgColors[type]} text-white px-6 py-3 rounded-lg shadow-xl flex items-center gap-3 min-w-[300px] max-w-md`}>
        <span className="text-xl font-bold">{icons[type]}</span>
        <span className="flex-1 whitespace-pre-line text-sm">{message}</span>
        <button
          onClick={onClose}
          className="text-white hover:text-gray-200 text-xl font-light hover:opacity-80 transition-opacity"
        >
          ×
        </button>
      </div>
    </div>
  );
}

